<template>
    <div>

    

    <table class="table table-striped table-bordered" v-if="lessons">

        <thead>
            <tr>
                <th>Course</th>
                <th>Title</th>
                <th>Week</th>
                <th></th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="lesson in lessons">
                <td>{{courseName(lesson.courseId)}}</td>
                <td>{{lesson.title}}</td>
                <td>{{lesson.week}}</td>
                <td>
                <router-link  :to="{ name: 'videoChapters', params: { courseId: lesson.courseId, instanceId: lesson.instanceId, videoId: lesson.id }}">
                    <button class="btn btn-sm btn-success">Open</button>
                </router-link> 
                    <!-- <span class="flag" v-if="lesson.complete === false">!</span> -->
                </td>

            </tr>

        </tbody>
    </table>
</div>
    
</template>



<script>

import videos from '../../../services/videos';

import toastr from 'toastr';

export default {
    data() {
        return {
            lessons:null
        }
    },
    props: ['courses'],
    mounted() {
        this.getLessons();

    },
    methods: {
        getLessons() {
            var self = this;
            videos.getMine(this).then(function(response) {
                console.log(response);
                if (response.data.success === true) {
                    self.lessons = response.data.lessons;
                } else {
                    toastr.error('Error getting your lessons');
                }
            })
        },
        courseName(courseId) {
            let index = this.courses.findIndex(function(c) {
                return c.course == courseId
            });
            return this.courses[index].associated.name;
        }
    }
}
</script>


<style lang="scss" scoped>
    table {
        tr td:last-child {
            text-align: center;
        }
    }
    .flag {
        color:red;
        float:right;
    }
</style>


// WEBPACK FOOTER //
// MyLessons.vue?3665589a